// These are navigation rules, not payment/subscription eligibility.
// Reduced and full sidebar menus use the same HG Super Pay entry.
export function getHgSuperPayMenu(profileStore, organisationStore) {
    const { currentProfileType, currentProfile } = profileStore;
    const isAudOrg = (organisationStore?.currency ?? "AUD") === "AUD";
    let link;
    let key = "hgSuperPay";

    if (currentProfileType === 1 || currentProfileType === 2) {
        if (isAudOrg) link = "/manage/hg-super-pay";
    } else if (currentProfileType === 3) {
        if (currentProfile?.hasOrganisation) {
            if (isAudOrg && (currentProfile.isOwnOrganization ||
                currentProfile.allowInvoices === true)) {
                link = "/organisation/hg-super-pay";
                key = "orgHgSuperPay";
            }
        } else if (currentProfile?.allowInvoices === true ||
            (currentProfile?.userId && currentProfile?.venue?.userId === currentProfile.userId)) {
            link = `/venues/${currentProfile.id}/hg-super-pay`;
        }
    }

    return link ? { icon: "fa fa-hand-holding-dollar", name: "HG Super Pay", link, key } : undefined;
}
